module.exports = __webpack_public_path__ + "static/img/mould7-1.cf84ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould7-1.png
// module id = VEn1
// module chunks = 3